import { useEffect } from "react";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

export default function Seo({ title, siteName, description, image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;

    const canonical = upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", url);

    const setMeta = (attr, key, content) => {
      const el = upsert(`meta[${attr}="${key}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute(attr, key);
        return m;
      });
      el.setAttribute("content", content);
    };

    setMeta("property", "og:url", url);
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (siteName) setMeta("property", "og:site_name", siteName);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    if (image) {
      const abs = window.location.origin + image;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:image", abs);
    }

    let script;
    if (jsonLd) {
      script = upsert('script[data-seo-jsonld="true"]', () => {
        const s = document.createElement("script");
        s.setAttribute("type", "application/ld+json");
        s.setAttribute("data-seo-jsonld", "true");
        return s;
      });
      script.textContent = JSON.stringify(jsonLd);
    }
  }, [title, siteName, description, image, jsonLd]);

  return null;
}
